export default ({ store }) => {
  if (!store.getters['licenses/profileLicenseListLoaded']) {
    return store
      .dispatch('licenses/loadProfileLicenseList')
      .catch(() => {})
  }
}
